import { Flex } from '../../../flex';
import { Text } from '../../../typography';
import { Actions, type MessagesSidebarItemActions } from '../actions';
import styles from './conversation-summary.module.css';
import { useFormatConversationTimestamp } from './hooks';

export type ConversationSummaryProperties = {
  actions?: MessagesSidebarItemActions;
  timestamp: Date;
  title: string;
  unread?: boolean;
};

const ConversationSummary = ({ actions, timestamp, title, unread }: ConversationSummaryProperties) => {
  const formattedTimestamp = useFormatConversationTimestamp(timestamp);

  return (
    <Flex align="center" gap="xxs">
      <Text className={styles.title} ellipsis type={unread ? 'primary' : 'title'} weight="medium">
        {title}
      </Text>
      <Text className={styles.timestamp} size="small" type={unread ? 'primary' : 'secondary'}>
        {formattedTimestamp}
      </Text>
      {actions ? <Actions {...actions} /> : null}
    </Flex>
  );
};

export default ConversationSummary;
